import { FC } from 'react';
import { Button, Stack, Typography } from '@mui/material';

import { useDictionary } from '@cvt/hooks/useDictionary';

import { BoxWell } from '@shared/components/BoxWell';
import { BorderColorOutlined } from '@mui/icons-material';
import isEmpty from 'lodash/isEmpty';
import { MessageFeedbackView } from '@cvt/components/MessageFeedbackView';


type Props = {
    icon?: React.ReactNode;
    title?: string;
    subtitle?: string;
    items?: string[];
    onEdit?: () => void;
};

export const PreferenceCard: FC<Props> = (props) => {
  const { icon, title, subtitle, items, onEdit } = props;
  const dictionary = useDictionary();

  return (
    <BoxWell
      sx={{
        p: { xs: 0, sm: 5 },
        borderColor: { xs: 'transparent', sm: 'divider' },
      }}
    >
      <Stack gap={2}>
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          alignItems={{ xs: 'flex-start', sm: 'center' }}
          justifyContent="space-between"
          gap={{ xs: 2, sm: 0 }}
        >
          <Stack direction="row" alignItems="center" gap={2}>
            {icon}

            <Typography variant="h5" component="h2" fontWeight={600} fontSize={18}>
              {title}
            </Typography>

          </Stack>
          <Button
            onClick={onEdit}
            variant="outlined"
            color="primary"
            size="small"
            sx={{ width: { xs: '100%', sm: 'auto' } }}
            startIcon={<BorderColorOutlined/>}
          >
            {dictionary.forms.buttonEdit}
          </Button>
        </Stack>

        <Typography variant="body2" component="h2" color="text.secondary" mt={1}>
          {subtitle}
        </Typography>

        <Stack spacing={1}>
          {items?.map((item, index) => (
            <BoxWell
              key={index}
              sx={{
                borderColor: '#f1f2f5',
                backgroundColor: '#f8f9fa',
              }}
            >
              <Stack key={index} direction="row" alignItems="center" gap={2}>
                <Typography variant="body2" component="span" flexShrink={0}>
                  {index + 1}.
                </Typography>
                <Typography variant="body2" component="span">
                  {item}
                </Typography>
              </Stack>
            </BoxWell>
          ))}

          {isEmpty(items) && (
            <MessageFeedbackView
              height={100}
              message="No items found"
            />
          )}
        </Stack>
      </Stack>
    </BoxWell>
  );
};
